import { Component, EventEmitter, Input, Output } from '@angular/core';
declare var bootstrap: any;

@Component({
    selector: 'app-modal-alert-control',
    templateUrl: './modal-alert-control.component.html',
    styleUrl: './modal-alert-control.component.css'})
export class ModalAlertControlComponent {
  @Input() id: string = 'defaultvalue';
  @Input() header: string = 'Header default value';
  @Input() body: string = '';
  @Input() closeButtonText: string = 'Close';
  @Input() okButtonText: string = 'Ok';
  

  @Output() onOkButtonClick = new EventEmitter<boolean>();

  

  handleClick() {
    
    this.onOkButtonClick.emit(true);
  }

}
